var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-body rounded-top"},[_c('component-table',{attrs:{"entityType":"exam_result","columns":_vm.columns,"data":_vm.list,"total":_vm.count,"hideSearchInput":true,"hideAddButton":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }